import React, { useState } from "react";

import StartPage from "../StartPage/startPage";
import Game from "../Game/game";

const Tetris = () => {
	/*
	const [runing, setRuning] = useState(false);
	return runing ? (
		<Game stopClick={() => setRuning(false)} />
	) : (
		<StartPage startClick={() => setRuning(true)} />
	);
	*/
	const [runing, setRuning] = useState(true); // skip StartPage

    return (
        <Game stopClick={() => setRuning(false)} />
    );
};

export default Tetris;